// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import RespuestaController from "./respuesta_controller"
application.register("respuesta", RespuestaController)

import SuscripcionesController from "./suscripciones_controller"
application.register("suscripciones", SuscripcionesController)

import ContentLoaderController from "./content_loader_controller.js"
application.register("content-loader", ContentLoaderController)

import ContentLoaderDivController from "./content_loader_div_controller.js"
application.register("content-loader-div", ContentLoaderDivController)

import SortableCsvController from "./sortable_csv_controller"
application.register("sortable-csv", SortableCsvController)

import Popover from 'stimulus-popover'
application.register('popover', Popover)

import Sortable from 'stimulus-sortable'
application.register('sortable', Sortable)

import TrixWordCountController from './trix_word_count_controller'
application.register('trix-word-count', TrixWordCountController)

import VerMasController from "./ver_mas_controller"
application.register("ver-mas", VerMasController)

import VerArbolDeCategoriasController from "./ver_arbol_de_categorias_controller"
application.register("ver-arbol-de-categorias", VerArbolDeCategoriasController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import StickyItemController from "./sticky_item_controller"
application.register("sticky-item", StickyItemController)

import OpenModalDialog from "./open_modal_dialog_controller"
application.register("open-modal-dialog", OpenModalDialog)

import FormSuccesMessage from "./form_succes_message_controller"
application.register("form-succes-message", FormSuccesMessage)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TableSliderController from "./table_slider"
application.register("table-slider", TableSliderController)

import TraducirController from "./traducir_controller"
application.register("traducir", TraducirController)

import PlayButtonController from "./play_button_controller"
application.register("play-button", PlayButtonController)

import RankitoMentionController from "./rankito_mention_controller"
application.register("rankito-mention", RankitoMentionController)
